module.exports = __webpack_public_path__ + "assets/fa-regular-400.261d666b0147c6c5cda07265f98b8f8c.eot";